var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.25 7.5C10.25 8.03043 10.0393 8.53914 9.66421 8.91421C9.28914 9.28929 8.78043 9.5 8.25 9.5C7.71957 9.5 7.21086 9.28929 6.83579 8.91421C6.46071 8.53914 6.25 8.03043 6.25 7.5C6.25 6.96957 6.46071 6.46086 6.83579 6.08579C7.21086 5.71071 7.71957 5.5 8.25 5.5C8.78043 5.5 9.28914 5.71071 9.66421 6.08579C10.0393 6.46086 10.25 6.96957 10.25 7.5Z",
    stroke: "#63666A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.25 7.5C13.25 12.2613 8.25 15 8.25 15C8.25 15 3.25 12.2613 3.25 7.5C3.25 6.17392 3.77678 4.90215 4.71447 3.96447C5.65215 3.02678 6.92392 2.5 8.25 2.5C9.57608 2.5 10.8479 3.02678 11.7855 3.96447C12.7232 4.90215 13.25 6.17392 13.25 7.5Z",
    stroke: "#63666A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/locationIcon.e5e1204f93cdc55e59f9b56ee12b11bd.svg";
export { ForwardRef as ReactComponent };